import axios from "axios";
import { DATA_STATUS } from "../mes_demandes/Data_status";

const apiUrl = process.env.REACT_APP_API_URL;
export const HistoriqueDemandeService = {
  async getAll() {
    const response = await axios.get(`${apiUrl}/offre_emploi`);
    return response.data;
  },

  async getById(id) {
    const response = await axios.get(`${apiUrl}/offre_emploi/${id}`);
    return response.data;
  },

  async create(data) {
    const response = await axios.post(`${apiUrl}/offre_emploi`, data);
    return response.data;
  },

  async update(id, data) {
    const response = await axios.put(`${apiUrl}/offre_emploi/${id}`, data);
    return response.data;
  },

  async delete(id) {
    const response = await axios.delete(`${apiUrl}/offre_emploi/${id}`);
    return response.data;
  },

  async getStatuByOffreId(id) {
    return {
      status: 200,
      success: true,
      data: DATA_STATUS.filter((item) => item.idOffre === id),
      message: "success",
    };
  },
};
